// LoadingSpinner.tsx
import React, { FunctionComponent } from "react";
import styled from 'styled-components'; 
import Box from '@mui/material/Box'; 
import CircularProgress, { circularProgressClasses, CircularProgressProps } from '@mui/material/CircularProgress'; 
import Colors from "../global/Colors";

const LoadingRoot = styled.div<{ size: string }>`
    position: relative;
    width: ${props => props.size === 'fullscreen' ? '100%' : '100%'};
    height: ${props => props.size === 'fullscreen' ? '100svh' : '100%'};
    min-height: ${props => props.size === 'small' ? '100%' : 'auto'};
    overflow: hidden; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

function CustomCircularProgress(props: CircularProgressProps & { colorMode?: 'light' | 'dark'; spinnerSize?: number }) {
    const { colorMode, spinnerSize, ...otherProps } = props;
    return (
        <Box sx={{ position: 'relative' }}>
            <CircularProgress variant="determinate" sx={{ color: colorMode === 'light' ? Colors.grayPale : Colors.grey9 }} size={spinnerSize} {...otherProps} value={100} />
            <CircularProgress variant="indeterminate" 
                sx={{ color: colorMode === 'light' ? Colors.grey4 : Colors.grey6, animationDuration: '800ms', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, [`& .${circularProgressClasses.circle}`]: { strokeLinecap: 'round' } }} size={spinnerSize} {...otherProps} />
        </Box>
    );
}

interface LoadingProps {
    size?: 'fullscreen' | 'medium' | 'small';
    colorMode?: 'light' | 'dark';
}

const LoadingSpinner: FunctionComponent<LoadingProps> = ({ size = 'fullscreen', colorMode = 'light' }) => {
    // Only set spinner size to 100 for fullscreen, use 24 for small
    const spinnerSize = size === 'fullscreen' ? 100 : size === 'medium' ? 48 : 24;
    
    return (
        <LoadingRoot size={size}>
            <CustomCircularProgress colorMode={colorMode} spinnerSize={spinnerSize} />
        </LoadingRoot>
    );
};

export default LoadingSpinner;
